"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class NavbarVerticalStyle2Module {
}
exports.NavbarVerticalStyle2Module = NavbarVerticalStyle2Module;
